import React from 'react';
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    CircularProgress,
    Collapse,
} from '@material-ui/core';
import Permissions from './Permissions';
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
export default function CreateRoleDialog({ open, onClose, onCreate, role }) {
    const [isPermissionsShown, setIsPermissionsShown] = React.useState(false);

    const handleClose = () => {
        onClose();
    }

    const handleSubmit = async (values) => {
        const resp = await onCreate(values, role?.id);
        if (resp) {
            handleClose();
        }
    };

    const handleNext = (values) => {
        if (values.name.length == 0) {
            Ext.Msg.alert("Error", "Please enter role name");
            return;
        }

        setIsPermissionsShown(true);
    }

    return (
        <Dialog
            open={open}
            maxWidth="sm"
            onClose={handleClose}
            PaperProps={
                {
                    style: {
                        minWidth: 600
                    }
                }
            }
        >
            <Formik
                initialValues={{
                    name: role?.name || "",
                    can_edit: role?.can_edit ?? 1,
                    can_delete: role?.can_delete ?? 1,
                    can_add: role?.can_add ?? 1,
                    can_view: role?.can_view ?? 1
                }}
                onSubmit={handleSubmit}
                validationSchema={
                    Yup.object().shape({
                        name: Yup.string().required("Name is required")
                    })
                }
            >
                {
                    props => {
                        const {
                            values,
                            touched,
                            errors,
                            dirty,
                            isSubmitting,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            handleReset
                        } = props;
                        return (
                            <form onSubmit={handleSubmit}>
                                <DialogTitle>Create New Role</DialogTitle>
                                <DialogContent>
                                    <TextField
                                        autoFocus
                                        id="name"
                                        value={values.name}
                                        onChange={handleChange}
                                        placeholder="Role name"
                                        onKeyPress={function (e) {
                                            if (e.charCode == 13) {
                                                handleNext(values);
                                                e.preventDefault();
                                            }
                                        }}
                                        type="text"
                                        fullWidth
                                    />
                                    {
                                        <Collapse in={isPermissionsShown} >
                                            <Permissions data={values} modifiedSheets={role?.modified_sheets || []} isNewRole={!role?.id} onChange={handleChange} />
                                        </Collapse>
                                    }
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose} color="primary">
                                        Cancel
                                    </Button>
                                    {
                                        isPermissionsShown ? <Button
                                            disabled={isSubmitting}
                                            className="plain_blue_btn"
                                            onClick={handleSubmit} color="primary">
                                            Save &nbsp;
                                            {isSubmitting && <CircularProgress size={20} />}
                                        </Button>
                                            :
                                            <Button
                                                onClick={() => handleNext(values)}
                                                color="primary"
                                                className="plain_blue_btn"
                                            >
                                                Set Permissions
                                            </Button>
                                    }
                                </DialogActions>
                            </form>
                        );
                    }
                }
            </Formik>
        </Dialog >
    );
}